/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CouponPromotionDetailsWithAssignmentCounts } from './CouponPromotionDetailsWithAssignmentCounts';
import {
    CouponPromotionDetailsWithAssignmentCountsFromJSON,
    CouponPromotionDetailsWithAssignmentCountsFromJSONTyped,
    CouponPromotionDetailsWithAssignmentCountsToJSON,
} from './CouponPromotionDetailsWithAssignmentCounts';

/**
 * 
 * @export
 * @interface CouponPromotionDetailsResponseWithAssignmentCounts
 */
export interface CouponPromotionDetailsResponseWithAssignmentCounts {
    /**
     * 
     * @type {Array<CouponPromotionDetailsWithAssignmentCounts>}
     * @memberof CouponPromotionDetailsResponseWithAssignmentCounts
     */
    details: Array<CouponPromotionDetailsWithAssignmentCounts>;
}

/**
 * Check if a given object implements the CouponPromotionDetailsResponseWithAssignmentCounts interface.
 */
export function instanceOfCouponPromotionDetailsResponseWithAssignmentCounts(value: object): value is CouponPromotionDetailsResponseWithAssignmentCounts {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function CouponPromotionDetailsResponseWithAssignmentCountsFromJSON(json: any): CouponPromotionDetailsResponseWithAssignmentCounts {
    return CouponPromotionDetailsResponseWithAssignmentCountsFromJSONTyped(json, false);
}

export function CouponPromotionDetailsResponseWithAssignmentCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponPromotionDetailsResponseWithAssignmentCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'details': ((json['details'] as Array<any>).map(CouponPromotionDetailsWithAssignmentCountsFromJSON)),
    };
}

export function CouponPromotionDetailsResponseWithAssignmentCountsToJSON(value?: CouponPromotionDetailsResponseWithAssignmentCounts | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'details': ((value['details'] as Array<any>).map(CouponPromotionDetailsWithAssignmentCountsToJSON)),
    };
}

